import { QueryParamsFromParentApp } from '../types';
import {
	DEFAULT_ELECTRIC_UNIT_PRICE, DEFAULT_SHADING_VAL, ENERGY_DERATE_RATE, TOOL_RENDER_MODE
} from '../../../../constants';

export function getDisplayModeFromUrl(): DisplayMode {
	const mode = new URLSearchParams(window.location.search).get('display-mode');
	return mode === 'dark' ? 'dark' : 'light';
}

export function getInitialState(): QueryParamsFromParentApp {
	return {
		billAmount: 0,
		designUUID: '',
		coordinates: null,
		externalId: '',
		electricUnitPrice: DEFAULT_ELECTRIC_UNIT_PRICE,
		derateRateBeforeUserSwitchToNonDefaultModes: ENERGY_DERATE_RATE,
		panelKey: '',
		parentAppName: '',
		annualEnergy: 0,
		lastEnergyInputChange: 'billAmount',
		energyDerateRate: ENERGY_DERATE_RATE,
		canRemoveShading: false,
		canEditSetback: false,
		stateCode: undefined,
		toolType: 'solar',
		displayMode: getDisplayModeFromUrl(),
		defaultShading: DEFAULT_SHADING_VAL,
		showLidarDate: false,
		toolRenderMode: TOOL_RENDER_MODE.DEFAULT
	};
}